import * as React from "react";
import { FC } from "react";
import { ChessPiece } from "../models/chessPiece";
import { pieceIcon } from "./pieceIcons";
import "./MovingAsChip.scss";

export type MovingAsChipProps = {
  piece?: ChessPiece;
};

/** Pill shown directly above the board announcing which piece's move is active. */
export const MovingAsChip: FC<MovingAsChipProps> = ({ piece }) => {
  const icon = pieceIcon(piece, true);
  return (
    <div className="movingAs" aria-live="polite">
      {piece ? (
        <>
          <img className="movingAs-icon" src={icon} alt="" aria-hidden="true" />
          <span className="movingAs-label">
            Moving as <strong>{piece}</strong>
          </span>
        </>
      ) : (
        <span className="movingAs-label">All pieces played</span>
      )}
    </div>
  );
};
